/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SwitchStatusResponse
 */
export interface SwitchStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof SwitchStatusResponse
     */
    oldVariant: string;
    /**
     * 
     * @type {string}
     * @memberof SwitchStatusResponse
     */
    targetVariant: string;
    /**
     * 
     * @type {boolean}
     * @memberof SwitchStatusResponse
     */
    inProgress?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SwitchStatusResponse
     */
    progression: number;
    /**
     * 
     * @type {number}
     * @memberof SwitchStatusResponse
     */
    total: number;
}

/**
 * Check if a given object implements the SwitchStatusResponse interface.
 */
export function instanceOfSwitchStatusResponse(value: object): value is SwitchStatusResponse {
    if (!('oldVariant' in value) || value['oldVariant'] === undefined) return false;
    if (!('targetVariant' in value) || value['targetVariant'] === undefined) return false;
    if (!('progression' in value) || value['progression'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function SwitchStatusResponseFromJSON(json: any): SwitchStatusResponse {
    return SwitchStatusResponseFromJSONTyped(json, false);
}

export function SwitchStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SwitchStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'oldVariant': json['oldVariant'],
        'targetVariant': json['targetVariant'],
        'inProgress': json['inProgress'] == null ? undefined : json['inProgress'],
        'progression': json['progression'],
        'total': json['total'],
    };
}

export function SwitchStatusResponseToJSON(value?: SwitchStatusResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'oldVariant': value['oldVariant'],
        'targetVariant': value['targetVariant'],
        'inProgress': value['inProgress'],
        'progression': value['progression'],
        'total': value['total'],
    };
}

